export default {"src":"/_next/static/media/icon-2-step-auth3.b6306f84.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};